export default __webpack_public_path__ + "static/media/Front-Apartment-Mr-El-Sayid-2.34de706b.jpg";